import type { ElementType, ReactNode } from 'react';

import styles from './box.module.css';

export interface RlBoxProps {
  variant?: 'large-container';
  children?: ReactNode;
}

/**
 * RlBox wraps box
 *
 */
export const RlBox: ElementType<RlBoxProps> = ({
  variant,
  children,
}: RlBoxProps) => {
  return (
    <div className={styles.rlBox} data-variant={variant}>
      {children}
    </div>
  );
};
